import ReactOnRails from 'react-on-rails';
import App from '../bundles/app/app-bundle.imports-loadable';

ReactOnRails.register({
  App,
});
